import { useParams } from "react-router-dom";
import { ObservationForm } from "src/containers";
import { useObservationFormQuery } from "src/hooks/useObservationForm";
import http from "src/libs/http";
import Error404 from "src/pages/Error404/Error404";

const FormDetail = () => {
	const params = useParams<{
		formId: string;
		observationId: number;
		userId: string;
		storeId: string;
	}>();
	const formId = parseInt(params.formId);

	const { error, data, isLoading, isSuccess } = useObservationFormQuery(formId);

	const renderObservationForm = () => {
		const questions = data?.observationQuestions;

		if (!questions || questions.length === 0) {
			return <p>This form has no questions!</p>;
		}

		if (!params.userId && !params.storeId) {
			return <p>No store or user selected.</p>;
		}

		return (
			<ObservationForm
				formId={formId}
				formName={data.name}
				questions={questions}
				observationId={params.observationId}
				observationType={data.observationType}
				userId={params.userId}
				storeId={params.storeId}
			/>
		);
	};

	if (http.isAxiosError(error) && error.response?.status === 404) {
		return <Error404 />;
	}

	return (
		<div>
			{http.isAxiosError(error) && <p>{error.message}</p>}

			{isLoading && (
				<div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
			)}

			{isSuccess && <>{renderObservationForm()}</>}
		</div>
	);
};

export default FormDetail;
